import PropTypes from 'prop-types';
import React from 'react';

import {assert} from 'Asserts';
import DataConnector from 'connect/DataConnector';
import EntityStore from 'stores/EntityStore';

import CreateOrganizationPage from './CreateOrganizationPage';
import CreateTeamPage from './CreateTeamPage';
import {
  CREATE_ORGANIZATION_SCREEN,
  CREATE_TEAM_SCREEN,
  MEMBER,
  MEMBER_INVITE,
  MEMBER_REQUEST,
  ORGANIZATION,
  ORGANIZATION_SCREEN,
  SHARE_PROJECTS_SCREEN,
  TEAM,
  TEAM_SCREEN,
  ALL_TABS,
  USER_SCREEN,
} from './OrganizationConstants';
import OrganizationPage from './OrganizationPage';
import PartyPageStore from './PartyPageStore';
import ShareProjectsPage from './ShareProjectsPage';
import TeamPage from './TeamPage';
import UserPage from './UserPage';

class PartyFullScreenViewConnector extends DataConnector {
  shouldSubscribeToRedux = false;
  stores = [EntityStore, PartyPageStore];

  enhanceProps() {
    const organization = this.partyPageStore().getCurrentOrganization();
    const team = this.partyPageStore().getCurrentTeam();
    let organizationMembers = null;
    if (organization) {
      organizationMembers = this.entityStore().getMembersForGroup(organization.id);
    }
    let teamMembers = null;
    if (team) {
      teamMembers = this.entityStore().getMembersForGroup(team.id);
    }
    return {
      activeTab: this.partyPageStore().getActiveTab(),
      isLoading: this.partyPageStore().getIsLoading(),
      organization,
      organizationMemberInvites: this.partyPageStore().getOrganizationMemberInvites(),
      organizationMemberRequests: this.partyPageStore().getOrganizationMemberRequests(),
      organizationMembers,
      organizationProjects: this.partyPageStore().getOrganizationProjects(),
      organizationTeams: this.partyPageStore().getOrganizationTeams(),
      team,
      teamMembers,
      teamProjects: this.partyPageStore().getTeamProjects(),
      userIdToMemberInfo: this.partyPageStore().getUserIdToMemberInfo(),
      userId: this.partyPageStore().getUserPageUserId(),
    };
  }
}

function PartyFullScreenView(props) {
  switch (props.currentScreen) {
    case ORGANIZATION_SCREEN:
      return (
        <OrganizationPage
          activeTab={props.activeTab}
          isLoading={props.isLoading}
          deprecatedOrganization={props.organization}
          organizationMemberInvites={props.organizationMemberInvites}
          organizationMemberRequests={props.organizationMemberRequests}
          organizationMembers={props.organizationMembers}
          organizationProjects={props.organizationProjects}
          organizationTeams={props.organizationTeams}
          userIdToMemberInfo={props.userIdToMemberInfo}
        />
      );
    case TEAM_SCREEN:
      return (
        <TeamPage
          activeTab={props.activeTab}
          isLoading={props.isLoading}
          deprecatedTeam={props.team}
          teamMembers={props.teamMembers}
          teamProjects={props.teamProjects}
          userIdToMemberInfo={props.userIdToMemberInfo}
        />
      );
    case USER_SCREEN:
      return <UserPage activeTab={props.activeTab} userId={props.userId} />;
    case CREATE_ORGANIZATION_SCREEN:
      return <CreateOrganizationPage organization={props.organization} isLoading={props.isLoading} />;
    case CREATE_TEAM_SCREEN:
      return <CreateTeamPage organizationId={props.organization.id} isLoading={props.isLoading} />;
    case SHARE_PROJECTS_SCREEN:
      return <ShareProjectsPage organizationId={props.organization.id} isLoading={props.isLoading} />;
    default:
      assert(false, `OrganizationView called with invalid screen: ${props.currentScreen}`);
  }
}

PartyFullScreenView.propTypes = {
  currentScreen: PropTypes.string.isRequired,
  activeTab: PropTypes.oneOf(ALL_TABS),
  isLoading: PropTypes.bool.isRequired,
  organization: ORGANIZATION,
  organizationMemberInvites: PropTypes.arrayOf(MEMBER_INVITE.isRequired),
  organizationMemberRequests: PropTypes.arrayOf(MEMBER_REQUEST.isRequired),
  organizationMembers: PropTypes.arrayOf(MEMBER.isRequired),
  organizationProjects: PropTypes.arrayOf(PropTypes.object),
  organizationTeams: PropTypes.array,
  team: TEAM,
  teamMembers: PropTypes.arrayOf(MEMBER.isRequired),
  teamProjects: PropTypes.arrayOf(PropTypes.object),
  userIdToMemberInfo: PropTypes.object,
  userId: PropTypes.string,
};

export default PartyFullScreenViewConnector.connect(PartyFullScreenView);
